<div>
    <div class="input-group">
        <input type="hidden" class="form-control"
            ngbDatepicker
            #datepicker="ngbDatepicker"
            [autoClose]="false"
            [displayMonths]="2"
            [dayTemplate]="t"
            outsideDays="hidden"
            firstDayOfWeek="7"
            [footerTemplate]="footerTemplate"
            [startDate]="displayDateFrom"
            [minDate]="minDate"
            [maxDate]="maxDate"
            (dateSelect)="onDateSelection($event)">
        <ng-template #t let-date let-focused="focused">
            <span class="custom-day"
                [class.focused]="focused"
                [class.range]="isRange(date)"
                [class.faded]="isHovered(date) || isInside(date)"
                [class.sunday]="isSunday(date)"
                [class.saturday]="isSaturday(date)"
                (mouseenter)="hoveredDate = date"
                (mouseleave)="hoveredDate = null">
                {{ date.day }}
            </span>
        </ng-template>
        <ng-template #footerTemplate>
            <hr class="my-0">
            <div class="d-flex bg-light p-2 align-items-center">
                <div>
                    <input type="text"
                        class="form-control form-control-sm"
                        placeholder="yyyy-mm-dd"
                        [(ngModel)]="inputDateFrom">
                </div>
                <div class="mx-1">-</div>
                <div>
                    <input type="text"
                        class="form-control form-control-sm"
                        placeholder="yyyy-mm-dd"
                        [(ngModel)]="inputDateTo">
                </div>
                <div class="flex-grow-1 text-right">
                    <button type="button"
                        class="btn btn-sm btn-success"
                        (click)="selectToday()">오늘</button>
                    <button type="button"
                        class="btn btn-sm btn-outline-info ml-2"
                        (click)="clickOk(datepicker)">확인</button>
                </div>
            </div>
        </ng-template>
    </div>

    <button type="button" class="btn nav-link calendar"
        (click)="clickOpen(datepicker)">
        <div class="d-flex align-items-center">
            <div class="">
                <i class="far fa-calendar-check fa-2x"></i>
            </div>
            <div class="ml-2 text-left small">
                <div class="text-muted">
                    기간선택
                </div>
                <div class="">
                    <span>{{formatter.format(datetimeInfo.fromDate)}}</span>
                    ~
                    <span>{{formatter.format(datetimeInfo.toDate)}}</span>
                </div>
            </div>
        </div>
    </button>
</div>